import React from 'react';
import ProjectsPage from '../components/projectsPage'

const Projects = () => {
    return (
        <ProjectsPage />
    )
}

export default Projects;